import { render, staticRenderFns } from "./FormSeplag.vue?vue&type=template&id=13bff266&scoped=true&"
import script from "./FormSeplag.vue?vue&type=script&lang=js&"
export * from "./FormSeplag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bff266",
  null
  
)

export default component.exports